import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {Button, Stack} from "react-bootstrap";
import {ResponsiveContent} from "../ResponsiveNavTabs";
import {useAlert, useAuth} from "../../context";
import {regex} from "../../utils2";
import {PageTitle, PasswordButton, SingleText} from "../_components";
import {Formik, Form as FormikForm} from "formik";
import * as yup from "yup";


export function ResetPassword() {
    return <ResponsiveContent body={<ResetPasswordBody/>}/>
}

function ResetPasswordBody() {

    const [searchParams] = useSearchParams({token: ""});
    const [token, setToken] = useState("");

    const navigate = useNavigate();
    const {resetPassword} = useAuth();
    const {success, error} = useAlert();

    useEffect(() => {
        const token = searchParams.get("token")
        if (token != null && token !== "" && token !== "undefined")
            setToken(token)
    }, []);

    const validationSchema = yup.object().shape({
        password: yup.string()
            .required("Password is mandatory.")
            .matches(regex.password_pattern, " Password must be at least 8 characters long and include a number, uppercase, lowercase, and special character."),
        token: yup.string()
            .required("Token is missing."),

    })

    const value = {
        password: "",
        token: token
    }

    function handleSubmit(values, actions) {
        resetPassword(values)
            .then(resp => {
                if (resp.success) {
                    navigate("/account/login");
                    success(<p>Password reset successfully, you can now login.</p>);
                } else {
                    error(resp.message, "Server error");
                }
            })
            .catch(console.warn)
            .finally(() => actions.setSubmitting(false))
    }


    return (
        <>
            <PageTitle title="Reset Password">Use the token received in the reset password email to reset your password.</PageTitle>

            <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={value} enableReinitialize={true}>
                {({isSubmitting, resetForm}) => (
                    <FormikForm>

                        {!token && <SingleText name="token" label="Token" type="textarea"/>}

                        <PasswordButton name="password" label="Password" position="right"/>

                        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                            <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                            <Button type="submit" variant="primary" disabled={isSubmitting}>Submit</Button>
                        </Stack>

                    </FormikForm>
                )}
            </Formik>
        </>
    )
}